import { css } from 'linaria';

export const firstRow = css`
  display: flex;
  align-items: baseline;
`;

export const secondRow = css`
  margin-top: var(--space-75);
`;

export const ratingWrapper = css`
  margin-left: 8px;
`;
